import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const globalMutations = {
  navBar: "navBar",
  detailModal: "detailModal"
};

export default new Vuex.Store({
  state: {
    navBar: false,
    detailModal: false
  },
  mutations: {
    [globalMutations.navBar](state, payload) {
      state.navBar = !state.navBar;
    },
    [globalMutations.detailModal](state, payload) {
      state.detailModal = !state.detailModal;
    }
  },
  actions: {}
});
